export const ADD_ITEM_START = '[ITEMS] ADD_ITEM_START';
export const ADD_ITEM_PROGRESS = '[ITEMS] ADD_ITEM_PROGRESS';
export const ADD_ITEM_END = '[ITEMS] ADD_ITEM_END';
export const ADD_ITEM_FAILURE = '[ITEMS] ADD_ITEM_FAILURE';
export const ADD_ITEM_SUCCESS = '[ITEMS] ADD_ITEM_SUCCESS';

export const EDIT_ITEM_START = '[ITEMS] EDIT_ITEM_START';
export const EDIT_ITEM_PROGRESS = '[ITEMS] EDIT_ITEM_PROGRESS';
export const EDIT_ITEM_END = '[ITEMS] EDIT_ITEM_END';
export const EDIT_ITEM_FAILURE = '[ITEMS] EDIT_ITEM_FAILURE';
export const EDIT_ITEM_SUCCESS = '[ITEMS] EDIT_ITEM_SUCCESS';

export const DELETE_ITEM_START = '[ITEMS] DELETE_ITEM_START';
export const DELETE_ITEM_PROGRESS = '[ITEMS] DELETE_ITEM_PROGRESS';
export const DELETE_ITEM_END = '[ITEMS] DELETE_ITEM_END';
export const DELETE_ITEM_FAILURE = '[ITEMS] DELETE_ITEM_FAILURE';
export const DELETE_ITEM_SUCCESS = '[ITEMS] DELETE_ITEM_SUCCESS';

export const CLEAR_ADD_ITEM_SUCCESS = '[ITEMS] CLEAR_ADD_ITEM_SUCCESS';
